import { useContext } from 'react';

import { SmxPermissionContext } from '../providers/permissionProvider';
import { PermissionCombinationType } from '../types';
import accessCheck from './accessCheck';

const useAccess = (accessFor: PermissionCombinationType[], isOwner?: boolean, isAssignee?: boolean) => {
    const { permissionListScore } = useContext(SmxPermissionContext);

    return accessCheck(permissionListScore, accessFor, isOwner, isAssignee);
};

export default useAccess;
